export default "__VITE_ASSET__CtcxC$bH__"